import debounce from "lodash.debounce";

/**
 * 劣化曲線の点の色をsurfaceConditionから取得
 * @param {*} value 
 * @param {*} surfaceCondition 
 * @returns 
 */
const getBackgroundColor = (value, surfaceCondition) => {
  let backgroundColor = "";
  for (let surface of surfaceCondition) {
    if (surface.rangeValue == null) {
      continue;
    }
    const rangeValue = JSON.parse(surface.rangeValue);
    const min = rangeValue[0];
    const max = rangeValue[1];

    if (value >= min && value <= max) {
      backgroundColor = surface.color;
    }
  }
  return backgroundColor;
};

/**
 * API取得→グラフデータ作成→グラフデータセット
 * road/graph/calculation/→単体
 * road/dashboard/graph/calculation/→複数(year毎)
 */
export const setGraphData = debounce(
  async ({
    // parameter
    dispatch,
    action,
    params,
    yearFilter,
    yearSlider,
    surfaces = [],
    deteriorationCurveList = [],
    deteriorationCurveId,
    // setter
    setGaugeChartData = (p) => {},
    setPieChartData = (p) => {},
    setDegradationChartData = (p) => {},
    setUnder4Score = (p) => {},
    setUnder3Score = (p) => {},
  }) => {
    /**
     * API Request
     * road/graph/calculation/ → Summary Tab
     * road/dashboard/graph/calculation/ → Dashboard
     */
    dispatch(action(params)).then((data) => {
      let loop = 1;
      // 複数(year毎)であるか
      let multiple = Object.keys(data ?? {}).every((key) => /^\d+$/.test(key));
      let dataList = [];
      let yearList = [];
      if (multiple && data != null) {
        dataList = JSON.parse(JSON.stringify(data));
        yearList = Object.keys(data);
        loop = yearList.length;
      }
      const newGaugeChartDataList = {};
      const newPieChartDataList = {};
      const newDegradationChartDataList = {};
      let _surfaces = [];
      // surface conditionはrangeValueの最大値降順
      // 上位7位固定
      try{
        _surfaces = [...surfaces]
        .slice()
        .sort((a, b) => {
          if (params.roadType == 'SPM_PCI' || params.roadType == "SPM_PCI_DP") {
            if (a.hasPredict) {
              const endA = JSON.parse(a.rangeValue).slice(-1)[0];
              const endB = JSON.parse(b.rangeValue).slice(-1)[0];
              return endB - endA;
            } else {
              return 0;
            }
          } else if (params.roadType == 'SPM_PASER') {
            if (!a.hasPredict) {
              const endA = parseInt(a.value, 10);
              const endB = parseInt(b.value, 10);
              return endA - endB;
            } else {
              return 0;
            }
          } else {
            return 0;
          }
        });
        if (params.roadType == 'SPM_PASER') {
          _surfaces = _surfaces.slice(0, 5);
        } else {
          _surfaces = _surfaces.slice(0, 7);
        }
      }catch(e){
        console.error(e);
      }
      for (let i = 0; i < loop; i++) {
        if(multiple){
          data = dataList[yearList[i]];
        }
        // データ構成の詳細はdummyData参照
        let newGaugeChartData = {
          datasets: [
            {
              value: 0, // 平均スコア
              data: [], // レンジデータ一覧
              backgroundColor: [], // レンジ色一覧
              labels: [], // レンジラベル一覧
              borderWidth: 0,
              label: "",
            },
          ],
        };
        let newPieChartData = {
          labels: [],
          datasets: [
            {
              data: [], // 割合データ一覧
              subData: [], // mileデータ一覧
              backgroundColor: [], // 背景色一覧
              borderWidth: 1,
              unit: "mi",
            },
          ],
        };
        let newDegradationChartData = {
          levelBands: [], // 損傷度のレベル帯
          lineData: [], // 劣化曲線データ
          currentData: [], // プロットデータ（current）
          predictionData: [], // プロットデータ（prediction）
        };
        try {
          if (data !== null) {
            // ゲージチャート
            if (data.averageScore !== null) {
              newGaugeChartData.datasets[0].value = Number(
                data.averageScore
              ).toFixed(0);
              const __surfaces = [..._surfaces].reverse()
              newGaugeChartData.datasets[0].data = __surfaces
                .map((surfaceCondition) => {
                  if (surfaceCondition.hasPredict) {
                    const rangeValue = JSON.parse(surfaceCondition.rangeValue);
                    return rangeValue[1] < rangeValue[0]
                      ? [rangeValue[1], rangeValue[0]]
                      : [rangeValue[0], rangeValue[1]];
                  } else {
                    return [surfaceCondition.value, surfaceCondition.value];
                  }
                })
                .flat();
              newGaugeChartData.datasets[0].backgroundColor = __surfaces
                .map((surfaceCondition, index) => {
                  if (index === 0) {
                    return surfaceCondition.color;
                  }
                  return [__surfaces[index - 1].color, surfaceCondition.color];
                })
                .flat();
              newGaugeChartData.datasets[0].labels = __surfaces
                .map((surfaceCondition, index) => {
                  if (index === 0) {
                    return surfaceCondition.title;
                  }
                  return [__surfaces[index - 1].title, surfaceCondition.title];
                })
                .flat();
              newGaugeChartData.loaded = true;
            }
            // パイチャート
            if (
              data.conditionCountList !== null &&
              data.conditionTotal !== null
            ) {
              const under4Score =
                data.conditionCountList
                  .filter((count, index) => index > 2)
                  .reduce((acc, curr) => acc + curr, 0) / 160.9344;
              setUnder4Score(under4Score.toFixed(1));

              const under3Score =
                data.conditionCountList
                  .filter((count, index) => index === 2)
                  .reduce((acc, curr) => acc + curr, 0) / 160.9344;
              setUnder3Score(under3Score.toFixed(1));

              newPieChartData.labels = _surfaces.map(
                (surfaceCondition) => surfaceCondition.title
              );
              newPieChartData.datasets[0].data = data.conditionCountList.map(
                (count) =>
                  Number((count * 100) / data.conditionTotal).toFixed(0)
              );
              newPieChartData.datasets[0].subData = data.conditionCountList.map(
                (count) => Number(count / 160.9344).toFixed(1)
              );
              newPieChartData.datasets[0].backgroundColor = _surfaces.map(
                (surfaceCondition) => surfaceCondition.color
              );
              newPieChartData.loaded = true;
            }
            // 劣化曲線
            newDegradationChartData.levelBands = _surfaces.map(
              (surfaceCondition, index) => {
                if (surfaceCondition.hasPredict) {
                  const rangeValue = JSON.parse(surfaceCondition.rangeValue);
                  return {
                    yMin: rangeValue[0],
                    yMax: rangeValue[1],
                    color: surfaceCondition.color,
                    label: surfaceCondition.title,
                    level: index + 1,
                  };
                } else {
                  const value = JSON.parse(surfaceCondition.value);
                  return {
                    yMin: value,
                    yMax: value,
                    color: surfaceCondition.color,
                    label: surfaceCondition.title,
                    level: index + 1,
                  };
                }
              }
            );
            const deteriorationCurve = deteriorationCurveList.find(
              (deteriorationCurve) =>
                deteriorationCurve.id == deteriorationCurveId
            );
            if (deteriorationCurve) {
              const backgroundColorSurface = getBackgroundColor(Math.round(data.currentCondition), _surfaces);
              const backgroundColorPrediction = getBackgroundColor(Math.round(data.averageScore), _surfaces);

              const xYear = JSON.parse(deteriorationCurve.xYear || "[]");
              const ySpm = JSON.parse(deteriorationCurve.ySpm || "[]");
              newDegradationChartData.lineData = xYear.map((x, i) => ({
                x,
                y: ySpm[i],
              }));
              const index1 = ySpm.findIndex(
                (spm) => spm == data.currentCondition?.toFixed(0)
              );
              const index2 = ySpm.findIndex(
                (spm) => spm == data.averageScore?.toFixed(0)
              );
              if(index1 > -1){
                newDegradationChartData.currentData = [
                  {
                    x: xYear[index1],
                    y: ySpm[index1],
                    title: `Current Condition`,
                    backgroundColor : backgroundColorSurface,
                  },
                ];
              }
              if (yearSlider?.isPredict && yearSlider?.isActual || (data.currentCondition == null || data.currentCondition == 0)) {
                newDegradationChartData.currentData = [{}];
              }
              if(index2 > -1){
                newDegradationChartData.predictionData = [
                  {
                    x: xYear[index2],
                    y: ySpm[index2],
                    title: `Prediction of ${yearFilter}`,
                    backgroundColor : backgroundColorPrediction
                  },
                ];
              }
            }
            newDegradationChartData.currentCondition = data.currentCondition;
            newDegradationChartData.averageScore = data.averageScore;
            newDegradationChartData.loaded = true;
            
          }
        } catch (e) {
          console.error(e);
        } finally {
          if (!multiple) {
            setPieChartData(newPieChartData);
            setGaugeChartData(newGaugeChartData);
            setDegradationChartData(newDegradationChartData);
          } else if (i < loop - 1) {
            newPieChartDataList[yearList[i]] = newPieChartData;
            newGaugeChartDataList[yearList[i]] = newGaugeChartData;
            newDegradationChartDataList[yearList[i]] = newDegradationChartData;
          } else {
            newPieChartDataList[yearList[i]] = newPieChartData;
            newGaugeChartDataList[yearList[i]] = newGaugeChartData;
            newDegradationChartDataList[yearList[i]] = newDegradationChartData;
            setPieChartData(newPieChartDataList);
            setGaugeChartData(newGaugeChartDataList);
            setDegradationChartData(newDegradationChartDataList);
          }
        }
      }
    });
  },
  2500,
  {
    leading: true,
    trailing: true,
    maxWait: 2500,
  }
);
